import type { ButtonHTMLAttributes, ReactNode } from "react";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "primary" | "secondary" | "danger" | "ghost";
  size?: "sm" | "md" | "lg";
  children: ReactNode;
}

const variants = {
  primary: "bg-[#b87800] hover:brightness-110 text-white shadow-md shadow-[#191c2a]",
  secondary: "bg-[#313949] hover:bg-[#3b4354] text-[#fafafc] border border-[#6f7084]",
  danger: "bg-[#cb505f]/20 hover:bg-[#cb505f]/30 text-[#cb505f]",
  ghost: "hover:bg-white/[0.04] text-[#9695a4] hover:text-[#fafafc]",
};

const sizes = { sm: "px-3 py-1.5 text-xs", md: "px-4 py-2 text-sm", lg: "px-5 py-2.5 text-sm" };

export function Button({ variant = "primary", size = "md", className = "", children, ...props }: ButtonProps) {
  return (
    <button className={`inline-flex items-center justify-center gap-2 font-medium rounded-lg transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed ${variants[variant]} ${sizes[size]} ${className}`} {...props}>
      {children}
    </button>
  );
}
